// Copyright (c) 2016 Deere & Company

export const productStatusNormalKeys = [
    '',
    'FOWN',
    'NEW',
    'NONE',
    'USED'
];

export const getProductStatusClassName = status =>
    productStatusNormalKeys.includes(status.key) ? 'product-status-icon' : 'dot-icon-red';



// WEBPACK FOOTER //
// ./src/product/shared/services/product-status.js